'use client';
import React from 'react';
import cx from 'classnames';
import { filterDataProps } from '@THC/utils/helpers';
import { useDotList } from './useDotList';
import styles from './DotList.module.scss';
export const DotList = (props) => {
    const { content } = useDotList(props);
    if (!content) {
        return null;
    }
    return (<ul className={cx(styles.dotList, {
            [styles.narrow]: props.narrow,
        })} {...filterDataProps(props)}>
			{content}
		</ul>);
};
